<template>
  <div>
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="sAPProductionOrders/selectWithPageV2"
        @select="selectAll"
        @select-all="selectAll">
      <div slot="toolbar" class="toolbar">
        <el-button v-if="cableAuth" type="success" :loading="printLoading" @click="gotoCablePrint()">线缆流转单</el-button>
      </div>
      <div slot="adSearch">
        <vm-search label="生产订单">
          <el-input v-model="filter.orders" placeholder="请输入生产订单" clearable/>
        </vm-search>
        <vm-search label="出厂编号">
          <el-input v-model="filter.factoryNum" placeholder="请输入出厂编号" clearable/>
        </vm-search>
      </div>
      <el-table-column type="selection" align="center" width="45"/>
      <el-table-column label="创建日期" prop="addDate" align="left" width="180"/>
      <el-table-column label="生产订单" prop="orders" align="left" width="100"/>
      <el-table-column label="物料编号" prop="materialNo" align="left" width="100"/>
      <el-table-column label="物料描述" prop="materialDescription" align="left" show-overflow-tooltip/>
      <el-table-column label="工单数量" prop="orderNum" align="left" width="80"/>
      <el-table-column label="销售订单" prop="saleOrderNo" align="left" width="120"/>
      <el-table-column label="出厂编号" prop="factoryNum" align="left" width="100"/>
      <el-table-column label="计划开始日期" prop="productStrart" align="left" width="180"/>
      <el-table-column label="计划结束日期" prop="productEnd" align="left" width="180"/>
    </vm-table>
    <edit-page ref="editPage" @save-success="getList(-1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable";
  import VmSearch from "@/components/VmSearch";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "ProductionOrderList",
    components: {VmTable, VmSearch},
    data() {
      return {
        printLoading: false,
        uploadUrl: window.config.basicServerUrl + "CablePrices/importFile",
        uploadHeaders: {"Authorization": loginUtil.getToken()},
        factoryNoList: [],
        cableAuth: this.$auth(608),
        filter: {
          orders: "",
          factoryNum: "",
        },
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      selectAll(selection) {
        this.selection = selection;
      },

      gotoCablePrint() {
        if (this.selection.length === 0) {
          this.$message.error("请选择至少一行记录");
          return;
        }
        this.factoryNoList = [];
        for (let item of this.selection) {
          this.factoryNoList.push(item.factoryNum);
        }
        this.$router.push({
          path: "/CablePrintProperty",
          query: {
            factoryNoList: this.factoryNoList,
          },
        });
      },

    },
  };
</script>

<style>

</style>